var React = require('react');

var Datepicker = require('./index.js');
var Input = require('../input');
var Row = require('../grid/row');
var Col = require('../grid/col');
var css = require('./module.scss');

/**
 * 使用方法：
 * <DatepickerGroup
        name='startTime'
        value={'2018-02-02'}
        more='endTime'
        moreValue={'2018-01-01'}
        wtype='2'
        size="lg"
    />
 */

var microSecondInDay = 24 * 60 * 60 * 1000;
var DatepickerGroup = React.createClass({

    getInitialState: function() {
        return {
            rangeIndex: -1
        };
    },

    /* setDate: function() {
		if(this.state.rangeIndex < 0) return;

		var range, start, end, d, startObj, endObj,
			option	= this.props.options[this.state.rangeIndex];
		if(!option) return;

		range = option.value.split('|');
		now = + new Date();
		start = new Date(now + (range[0] * microSecondInDay));
		end = range[1] ? new Date(now + (range[1] * microSecondInDay)) : start;
		startObj = this.refs[this.props.name].getTarget();
		startObj.value = this.formatDate(start);
		startObj.blur();

		if(this.props.more) {
			endObj = this.refs[this.props.more].getTarget();
			endObj.value = this.formatDate(end);
			endObj.blur();
		}
	},

	formatDate: function(d) {
		return d.getFullYear() + '-' + this.zerofill(d.getMonth() + 1) + '-' + this.zerofill(d.getDate());	// + ' ' + this.zerofill(d.getHours()) + ':' + this.zerofill(d.getMinutes()) + ':' + this.zerofill(d.getSeconds());
	},

	zerofill: function(num) {
		return num < 10 ? '0' + num.toString() : num;
	},
*/
    showRange: function(index) {
        this.setState({
            rangeIndex: index
        });
    },

    componentDidUpdate: function() {
        // this.setDate();
    },

    onDateChange: function(value) {
        this.setState({
            rangeIndex: -1
        });

        this.props.onChange && this.props.onChange(value);
    },

    onMoreDateChange: function(value) {
        this.setState({
            rangeIndex: -1
        });

        this.props.onMoreChange && this.props.onMoreChange(value);
    },

    render: function() {
        var _this = this;
        var phs = this.props.placeholder ? this.props.placeholder.split('|') : [];
        var cls = ['fp-datePicker-group'];
        if (this.props.className) {
            cls.push(this.props.className);
        }
        return (
            <Row className={cls.join(' ')}>
                <Col span={11}>
                    <Datepicker
                        ref={this.props.name}
                        name={this.props.name}
                        value={this.props.value}
                        onChange={this.onDateChange}
                        placeholder={phs[0]}
                        size={this.props.size}
                        wtype={this.props.wtype}
                        dateFmt={this.props.dateFmt}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                    />
                </Col>
                {
                    this.props.more ? <Col span={2} className="fp-datepicker-text">—</Col>
                        : null
                }
                {
                    this.props.more ? (
                        <Col span={11}><Datepicker
                            ref={this.props.more}
                            name={this.props.more}
                            value={this.props.moreValue}
                            onChange={this.onMoreDateChange}
                            placeholder={phs[1]}
                            size={this.props.size}
                            wtype={this.props.wtype}
                            dateFmt={this.props.dateFmt}
                            minDate={this.props.moreMinDate}
                            maxDate={this.props.moreMaxDate}
                        /></Col>
                    ) : null
                }
            </Row>
        );
    }

});

module.exports = DatepickerGroup;



// WEBPACK FOOTER //
// ./component/datepicker/group.js